import { useContext } from "react";
import { useTranslation } from "@/i18n/client";
import { EnumerationsContext } from "@/contexts/EnumerationsContext";
import Select from "@/components/Select";
import { getMappedEnumToSelect } from "@/screens/common/Degree/helpers";
import { executiveRoleId } from "@/constants/executivePerson";
import { FormInputProps } from "@/types";

interface ExecutiveRoleProps {
  executiveRoleProps: FormInputProps;
  disabled?: boolean;
  onResetBirthDate: () => void;
  onSetExecutiveRoleId: (value: string) => void;
}

export const ExecutiveRole = ({ executiveRoleProps, disabled, onResetBirthDate, onSetExecutiveRoleId }: ExecutiveRoleProps) => {
  const enums = useContext(EnumerationsContext);
  const { t } = useTranslation("company");

  return (
    <Select
      searchable
      disabled={disabled}
      label={t("executiveRole")}
      data={getMappedEnumToSelect(enums.executiveRoles)}
      {...executiveRoleProps}
      onChange={() => null}
      onOptionSubmit={value => {
        if (value === executiveRoleId) {
          onResetBirthDate();
        }
        onSetExecutiveRoleId(value);
      }}
    />
  );
};
